'use client';

import Link from 'next/link';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { Checkbox } from '@/shared/ui/core';
import { ClearableInput } from '@/shared/ui/kit/clearable-input';
import { IMPRINT_PATHNAME, TERMS_PATHNAME } from '@/shared/constants/pathnames';
import { SignupCredentialsFormData } from '@/shared/lib/validation/registration-wizard/credentials';
import { PasswordField } from './password-field';


export const CredentialsFields = () => {
    const { register, control, formState: { errors }, setValue, clearErrors, trigger } = useFormContext<SignupCredentialsFormData>();
    const email = useWatch({ control, name: 'email' });

    return (
        <>
            <ClearableInput
                label="E-mail:"
                placeholder="mail@example.com"
                autoComplete="email"
                type="email"
                error={ errors.email?.message }
                required
                value={ email }
                onClear={ () => setValue('email', '', { shouldValidate: true }) }
                { ...register('email') }
                onFocus={ () => clearErrors('email') }
            />

            <PasswordField/>

            <Controller
                control={ control }
                name="terms"
                render={ ({ field }) => (
                    <Checkbox
                        checked={ field.value }
                        onCheckedChange={ (val) => {
                            field.onChange(val);
                            trigger('terms');
                        } }
                        error={ errors.terms?.message }
                        label={
                            <>
                                I agree to the&nbsp;
                                <Link
                                    href={ TERMS_PATHNAME }
                                    prefetch={ false }
                                    target='_blank'
                                >
                                    Terms and Conditions
                                </Link>
                                &nbsp;and&nbsp;
                                <Link
                                    href={ IMPRINT_PATHNAME }
                                    prefetch={ false }
                                    target='_blank'
                                >
                                    Privacy Policy
                                </Link>
                            </>
                        }
                        required
                    />
                ) }
            />
        </>
    );
};
